import Service from '@ember/service';

export default class SessionStorageService extends Service {
  unknownProperty(key: string): unknown {
    return window.sessionStorage[key];
  }

  setUnknownProperty<T>(key: string, value: T): T {
    if (value == null) {
      window.sessionStorage.removeItem(key);
    } else {
      window.sessionStorage[key] = value;
    }
    // eslint-disable-next-line ember/classic-decorator-no-classic-methods
    this.notifyPropertyChange(key);
    return value;
  }

  [key: string]: unknown;
}
